<!-- src/components/TableHeader.vue -->

<template>
    <tr class="table-header">
        <th v-if="multiselect"
            class="table-th text-left px-4 py-2 bg-cal-blue text-white text-sm hover:underline">
            <input type="checkbox" v-model="selectAll" @click="toggleCheckboxAll()" />
        </th>
        <th v-for="(column, index) in columns"
            v-bind:key="column.title"
            class="table-th text-left px-4 py-2 bg-cal-blue text-white text-sm hover:underline"
            :class="{ 'sortable': column.sortable === false, 'cursor-pointer': column.sortable !== false }"
            @click="toggleSort(column, index)">
            {{ column.title }}
            <span v-if="sort == index && direction == 'desc'">&#8595;</span>
            <span v-if="sort == index && direction == 'asc'">&#8593;</span>
        </th>
    </tr>
</template>

<script>
export default {
    data () {
        return {
            selectAll: false,
        }
    },
    props: {
        columns: null,
        rows: null,
        sort: null,
        direction: String,
        multiselect: {
            default: false
        }
    },

    methods: {
        toggleSort(column, index) {
            if (column.sortable != null && column.sortable === false) return;
            this.$emit('sort-toggle', index);
        },

        toggleCheckboxAll() {
            if (this.selectAll == false) {
                this.$emit('table-select-all');
            }
            else {
                this.$emit('table-unselect-all');
            }
        }
    },
  watch: {
    'rows': function () {
      this.selectAll = false;
    }
  }
}
</script>
